import { required, email } from 'utils/validation'

export default function(values) {
  return {
    to: required(values.to) || email(values.to),
    subject: required(values.subject),
    message: required(values.message)
  }
}
